import { gql } from '@apollo/client';

export const GET_APPOINTMENT_AGENT_SETTINGS_USE = gql`
  query getAppointmentAgentSettingsUse($id: String!) {
    voiceStepConversationalSchedulingAgent(appointmentAgentSettingsId: $id) {
      id
    }
  }
`;
